<template>
  <div class="card mb-25 border-0 rounded-0 bg-white add-user-card">
    <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing">
      <div v-if="recensement">
        <div class="d-flex justify-content-between align-items-center mb-20">
          <h4 class="card-title fw-bold mb-0">
            {{ recensement.nom }} {{ recensement.prenom }}
          </h4>
          <router-link to="/liste-recensements"
            class="btn btn-danger transition border-0 lh-1 fw-medium">
            <i class="flaticon-delete lh-1 me-1 position-relative top-2"></i>
            Retour
          </router-link>
        </div>

        <div class="row">
          <div class="col-md-6 mb-15">
            <span class="d-block text-body-tertiary fs-13 text-uppercase">Date de naissance</span>
            <span class="fw-semibold text-black">{{ recensement.dateNaissance }}</span>
          </div>
          <div class="col-md-6 mb-15">
            <span class="d-block text-body-tertiary fs-13 text-uppercase">Lieu de naissance</span>
            <span class="fw-semibold text-black">{{ recensement.LieuNaissance }}</span>
          </div>
          <div class="col-md-6 mb-15">
            <span class="d-block text-body-tertiary fs-13 text-uppercase">Contact</span>
            <span class="fw-semibold text-black">{{ recensement.contact }}</span>
          </div>
          <div class="col-md-6 mb-15">
            <span class="d-block text-body-tertiary fs-13 text-uppercase">Pays d'origine</span>
            <span class="fw-semibold text-black">{{ recensement.paysOrigine }}</span>
          </div>
          <div class="col-md-6 mb-15">
            <span class="d-block text-body-tertiary fs-13 text-uppercase">Pays de résidence</span>
            <span class="fw-semibold text-black">{{ recensement.PaysResidence }}</span>
          </div>
          <div class="col-md-6 mb-15">
            <span class="d-block text-body-tertiary fs-13 text-uppercase">Ville de résidence</span>
            <span class="fw-semibold text-black">{{ recensement.villeResidence }}</span>
          </div>
          <div class="col-md-6 mb-15">
            <span class="d-block text-body-tertiary fs-13 text-uppercase">D'Adjohoun</span>
            <span :class="recensement.jeSuisDadjohoun ? 'badge text-white bg-success' : 'badge text-white bg-secondary'">
              {{ recensement.jeSuisDadjohoun ? 'Oui' : 'Non' }}
            </span>
          </div>
          <div class="col-md-6 mb-15">
            <span class="d-block text-body-tertiary fs-13 text-uppercase">Partisan</span>
            <span :class="recensement.jeSuisPartisan ? 'badge text-white bg-success' : 'badge text-white bg-secondary'">
              {{ recensement.jeSuisPartisan ? 'Oui' : 'Non' }}
            </span>
          </div>
        </div>

        <div class="mt-20">
          <span class="d-block text-body-tertiary fs-13 text-uppercase mb-10">Description</span>
          <span class="d-block fw-semibold text-black" style="white-space: pre-wrap">{{ recensement.description || '—' }}</span>
        </div>

        <div class="mt-20">
          <span class="d-block text-body-tertiary fs-13 text-uppercase mb-10">Secteurs d'activité</span>
          <div v-if="recensement.secteuractivites && recensement.secteuractivites.length">
            <span v-for="secteur in recensement.secteuractivites" :key="secteur.id"
              class="badge bg-primary text-white me-5 mb-5">
              {{ secteur.libelle }}
            </span>
          </div>
          <span v-else class="text-body-tertiary">Aucun secteur d'activité renseigné.</span>
        </div>
      </div>
      <div v-else class="text-center text-body-tertiary py-20">
        Chargement...
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, ref } from "vue";
import { useRoute } from "vue-router";
import ApiService from "../../services/ApiService";
import { error } from "../../utils/utils";
import { Recensement } from "../../models/Recensement";

export default defineComponent({
  name: "ViewRecensement",
  setup() {
    const route = useRoute();
    const recensementId = Number(route.params.id);
    const recensement = ref<Recensement | null>(null);

    const getRecensement = async (id: number) => {
      try {
        const response = await ApiService.get(`/recensements/${id}`);
        recensement.value = response.data.data;
      } catch (err: any) {
        error(err.response?.data?.message || "Erreur lors du chargement");
      }
    };

    onMounted(() => {
      if (recensementId && !isNaN(recensementId)) {
        getRecensement(recensementId);
      }
    });

    return {
      recensement,
    };
  },
});
</script>
